import React, { Component } from 'react'
import { connect } from 'react-redux'
import './styles.css'

import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'
import ReactTooltip from 'react-tooltip'
import Sidebar from 'react-sidebar'
import DocDrawer from './drawer'

class Documentation extends Component {
    state = {
        phase: 0,
        userAttributes: null,
        errorMessage: null,
        username: null,
        cognitoUser: null,
        disabled: true,
        changePasswordDisabled: true
    }

    render() {
        const sidebar = <DocDrawer />

        const sidebarProps = {
            sidebar: sidebar,
            docked: true,
            open: true,
            onSetOpen: null
        }

        let marginTopParagraph = '40px'

        return (
            <Sidebar {...sidebarProps}>
                <div className="">
                    <div className="doc-page" style={{ 'margin-bottom': '100px', 'text-align': 'left', padding: '20px', background: '#f1f2f7' }}>
                        <WhiteBox>
                            <div className="row" id="doc_integrations">
                                <div className="col">
                                    <h2 style={{ 'border-bottom': '1px solid lightgray', 'margin-bottom': '20px' }} className="">
                                        Audience Rate Customer Service Level Agreement
                                    </h2>
                                    <p>
                                        This AudienceRate Client Service Level Agreement (“SLA”) between AudienceRate and users of the AudienceRate Platform
                                        outlines the procedures and policies for client services between AudienceRate and users of the AudienceRate Platform.{' '}
                                        <br />
                                        <br />
                                        In order to provide optimal customer service to all users, all issues must be received by one of the methods outlined
                                        below.
                                        <br />
                                        <br />
                                        This SLA applies specifically to customer service needs related to the AudienceRate platform and its functionality. This
                                        SLA does not apply to other business or legal issues or needs.
                                    </p>
                                </div>
                            </div>
                        </WhiteBox>
                        <WhiteBox>
                            <div className="row" id="doc_integrations">
                                <div className="col">
                                    <h2 style={{ 'border-bottom': '1px solid lightgray', 'margin-bottom': '20px' }} className="">
                                        SERVICE CHANNELS{' '}
                                    </h2>
                                    <p>
                                        Below are methods in which AudienceRate platform users can access information regarding the platform, common issues, or
                                        access the assistance of an AudienceRate team member.
                                    </p>

                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        AudienceRate Documentation Library
                                    </h3>
                                    <p>
                                        A user can search an issue through the “Contact Us” widget located in the lower right hand corner of the AudienceRate
                                        Platform or by visiting our online documentation repository found{' '}
                                        <a href="https://app.audiencerate.com/doc/home">here</a>.
                                    </p>

                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        AudienceRate Ticketing System
                                    </h3>
                                    <p>
                                        <div className="row">
                                            <div className="col">
                                                AudieneRate leverages Jira Helpdesk as its customer service platform. AudienceRate clients can access Jira
                                                helpdesk and file a ticket through the “Contact Us” widget located in the lower right hand corner of the
                                                AudienceRate platform.
                                                <br />
                                                <br />
                                                <img height="70" src="/img/contact_us1.png"></img>
                                            </div>
                                            <div className="col">
                                                Enter an issue in the search field and links to our documentation will appear as well as an option for
                                                “technical support.” Click on the “technical support” link and you will be prompted to enter your issue.
                                                <br />
                                                <br />
                                                <img height="500" src="/img/contact_us2.png"></img>
                                            </div>
                                            <div className="col">
                                                In the form you will enter the ticket title and message, you can upload a file or image and you will need to
                                                enter your email.
                                                <br />
                                                <br />
                                                <img height="500" src="/img/contact_us3.png"></img>
                                            </div>
                                        </div>
                                        <br />
                                        Response time - maximum 24 hours from ticket filing.
                                    </p>
                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Email Escalation
                                    </h3>
                                    <p>
                                        If for some reason a ticket has gone unanswered or is not being sufficiently resolved. A user can send an escalation
                                        email directly to the email alias <a href="mailto:admin@audiencerate.com">admin@audiencerate.com</a>
                                    </p>
                                </div>
                            </div>
                        </WhiteBox>
                    </div>
                </div>
            </Sidebar>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(Documentation)
